type DeliveryArea = {
  locality: string
}

export function deliveryPlaces(areas: readonly DeliveryArea[]): string[] {
  const seen = new Set<string>()
  const places: string[] = []

  for (const area of areas) {
    for (const value of area.locality.split(',')) {
      const place = value.trim()
      const key = place.toLocaleLowerCase('en-IN')
      if (!place || seen.has(key)) continue
      seen.add(key)
      places.push(place)
    }
  }

  return places
}

export function singleDeliveryPlace(
  areas: readonly DeliveryArea[],
): string | null {
  const places = deliveryPlaces(areas)
  return places.length === 1 ? places[0] : null
}
